import PropTypes from "prop-types";
import Link from "next/link";
import { getSanityNextImage } from "@lib/getImages";
import styles from "./styles/hero.module.css";

export function Hero({ editorial }) {
  if (!editorial) {
    return null;
  }
  if (!editorial.card) {
    return null;
  }
  const { cardImage, heading, cta } = editorial.card;

  return (
    <Link href={`/editorials/${editorial.slug.current}`}>
      <a>
        <div className={styles.hero}>
          <div className={styles.content}>
            <h2>{heading}</h2>
            <h3>{cardImage.caption}</h3>
            <p>{cta}</p>
          </div>
          {getSanityNextImage(
            cardImage,
            { small: "800", medium: "1600", large: "2400" },
            cardImage.altText,
            "cover"
          )}
        </div>
      </a>
    </Link>
  );
}

Hero.propTypes = {
  editorial: PropTypes.shape({
    card: PropTypes.shape({
      cardImage: PropTypes.shape({
        altText: PropTypes.string.isRequired,
        caption: PropTypes.string.isRequired,
        asset: PropTypes.object.isRequired,
      }),
      heading: PropTypes.string.isRequired,
      subheading: PropTypes.string.isRequired,
    }).isRequired,
    slug: PropTypes.shape({
      current: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
